import React from "react";
import "./Modal.css"
import logo from "../../assets/images/logo.png"
import article from "../../assets/images/article.png"
import wiki from "../../assets/images/wiki.png"
import youtube from "../../assets/images/youtube.png"
import FlightDetails from '../../subComponents/FlightDetails'
import { getLaunchStatus, getStatusColor, getLocation } from '../../controllers'
import * as dayjs from "dayjs";

const Modal = ({ handleClose, data }) => {

  return (
    <div className="modal_box">
      <div className="box">
        <span className="close_icon" onClick={handleClose}>x</span>
        <div className="modal_top">
          <div className="modal_topLogo">
            <img src={logo} alt="" srcset="" />
          </div>
          <div className="modal_topInfo">
            <div className="modal_infoTop">
              <div className="modal_info">
                <div className="modal_infoName">
                  {data.name}
                </div>
                <div className="modal_infoStatus">
                  <button className={`statusButton ${getStatusColor(data)}`}>       {getLaunchStatus(data)}</button>
                </div>
              </div>
              <div className="modal_infoRocket">
                {data.rocket === '5e9d0d95eda69955f709d1eb' ? "Falcon 8" : "Falcon 9"}
              </div>
              <div className="modal_infoLinks">
                {data.links.article && (
                  <div className="modal_infoLinkWiki">
                    <a href={data.links.article} target="_blank"><img src={article} alt="" srcset="" /></a>
                  </div>
                )}
                {data.links.wikipedia && (
                  <div className="modal_infoLinkWiki">
                    <a href={data.links.wikipedia} target="_blank"><img src={wiki} alt="" srcset="" /></a>
                  </div>
                )}
                {data.links.webcast && (
                  <div className="modal_infoLinkYoutube">
                   <a href={data.links.webcast} target="_blank"><img src={youtube} alt="" srcset="" /></a>
                  </div>
                )}
                
              </div>
            </div>
          </div>
        </div>
        <div className="modal_middle">
          <div className="modal_middleData">
            {data.name} was inserted into abnormally low orbit and lost due to Falcon 9 boost stage engine failure, and the primary payload owner's contractual right to decline a second ignition of the second stage under some condition.{data.links.wikipedia && (
                <a href={data.links.wikipedia} target="_blank">Wikipedia</a>
            )}
          </div>
          <div>
            
          </div>
        </div>
        <div className="modal_bottom">
          <FlightDetails label={"Flight Number"} data={data.flight_number}/>
          <FlightDetails label={"Mission Name"} data={data.name}/>
          <FlightDetails label={"RocketType"} data={"v1.0"}/>
          <FlightDetails label={"Rocket Name"} data={data.rocket === '5e9d0d95eda69955f709d1eb' ? "Falcon 8" : "Falcon 9"}/>
          <FlightDetails label={"Manufacturer"} data={"SpaceX"}/>
          <FlightDetails label={"Nationality"} data={"SpaceX"}/>
          <FlightDetails label={"Launch Date"} data={dayjs(data.                launch_date_local).format(
                            "D MMMM YYYY at h:mm"
          )}/>
          <FlightDetails label={"Payload Type"} data={data.payload === "5eb0e4b5b6c3bb0006eeb1e1" ? "Dragon 1" : "Dragon 2"}/>
          <FlightDetails label={"Orbit"} data={data.tbd === true ? "ISS" : "LEO"}/>
          <FlightDetails label={"Launch Site"} data={getLocation(data)} border={false}/>
        </div>
          
      </div>
    </div>
  );
};

export default Modal;